import { sel } from 'fxjs/es';
import { UtilS } from '../../../../../Util/S/Function/module/UtilS.js';

export const formatToProductUrl = (url) =>
  UtilS.isNessApp()
    ? sel('0', url.match(/https:\/\/(\w+\.)?essential.nexon.com\/\w+\/.+\/products\/\d+/))
    : sel('0', url.match(/https:\/\/(\w+\.)?marpple.shop\/\w+\/.+\/products\/\d+/));
